import { createContext, useContext, useEffect, useState, useCallback } from "react";

const CartContext = createContext(null);
const KEY = "ol_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState({}); // product_id -> { product, quantity }

  useEffect(() => {
    try {
      const saved = JSON.parse(localStorage.getItem(KEY) || "{}");
      setItems(saved);
    } catch {
      setItems({});
    }
  }, []);

  const persist = useCallback((next) => {
    setItems(next);
    localStorage.setItem(KEY, JSON.stringify(next));
  }, []);

  const addItem = (product, qty = 1) => {
    const next = { ...items };
    const ex = next[product.id];
    next[product.id] = { product, quantity: (ex?.quantity || 0) + qty };
    persist(next);
  };

  const setQty = (productId, qty) => {
    const next = { ...items };
    if (qty <= 0) {
      delete next[productId];
    } else if (next[productId]) {
      next[productId] = { ...next[productId], quantity: qty };
    }
    persist(next);
  };

  const remove = (productId) => {
    const next = { ...items };
    delete next[productId];
    persist(next);
  };

  const clear = () => {
    persist({});
  };

  const lines = Object.values(items);
  const total = lines.reduce((sum, l) => sum + Number(l.product.price_net) * Number(l.quantity), 0);
  const count = lines.reduce((sum, l) => sum + Number(l.quantity), 0);

  return (
    <CartContext.Provider value={{ items, lines, total, count, addItem, setQty, remove, clear }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return useContext(CartContext);
}
